export default __webpack_public_path__ + "static/media/clients-landing-2.012a818c.jpg";